<template>
  <div class="p-4">
    <DxDataGrid class="salarii-grid" :data-source="dsValoriParametriiSalarizare" key-expr="ID"
      :remote-operations="false" :show-row-lines="true" :hover-state-enabled="true" :show-borders="true" :onCellPrepared="onCellPrepared">
      <DxSelection mode="single" />
      <DxFilterRow :visible="true" />
      <DxPaging :page-size="20" />
      <DxLoadPanel :enabled="true" />
      <DxSorting mode="multiple" />
      <DxColumn data-field="Cod" caption="Cod" />
      <DxColumn data-field="Nume" caption="Denumire" />
      <DxColumn data-field="Valoare" caption="Valoare" />
    </DxDataGrid>
  </div>
</template>

<script lang="ts">
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
} from "devextreme-vue/data-grid";
import { defineComponent } from "vue";
import ValoriParametriSalarizare from "@/services/PER/ValoriParametriSalarizare";

export default defineComponent({
  components: {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
  },
  props: {
    empId: {
      type: String,
      required: false,
    },
    mode: {
      type: String,
      required: false,
      default: "Angajati",
    },
  },
  data() {
    return {
      dsValoriParametriiSalarizare: [] as any[],
    };
  },
  watch: {
    empId: {
      immediate: true,
      handler(newVal) {
        this.reload(newVal, this.mode);
      },
    },
    mode(newVal) {
      this.reload(this.empId, newVal);
    },
  },
  methods: {
    async reload(empId?: string | null, mode?: string) {
      if (!empId) {
        this.dsValoriParametriiSalarizare = [];
        return;
      }

      try {
        let resp;
        if (mode === "Companie") {
          resp =
            await ValoriParametriSalarizare.GetValoriParametriSalarizareCompanie(
              empId
            );
        } else {
          resp =
            await ValoriParametriSalarizare.GetValoriParametriSalarizareAngajat(
              empId
            );
        }

        const data = resp?.data || [];
        const arr = data.map((x: any, idx: number) => ({
          ID: x.ID ?? x.Cod ?? idx + 1,
          ...x,
        }));
        this.dsValoriParametriiSalarizare = arr;
      } catch (err) {
        console.error(err);
        this.dsValoriParametriiSalarizare = [];
      }
    },
     onCellPrepared(e) {
    if (e.rowType === "data" && (e.columnIndex === 0 || e.columnIndex === 1)) {
      e.cellElement.style.backgroundColor = "#f3f732";
      e.cellElement.style.fontWeight = "600";
    }
  },
  },
});
</script>
<style scoped>
.salarii-grid {
  flex: 1;
  width: 100%;
  border: 1px solid #9db0d4;
  box-sizing: border-box;
}

::v-deep .salarii-grid .dx-datagrid-rowsview .dx-row>td {
  height: 10px;
  padding: 8px 6px;
}

/* header albastru */
.salarii-grid .dx-datagrid-headers {
  background: #3b5485;
  color: #fff;
  font-weight: 600;
  border-bottom: 1px solid #2f446a;
}

/* alternanta */
.salarii-grid .dx-row-alt {
  background: #f6f8fb;
}

/* rand selectat */
.salarii-grid .dx-datagrid-rowsview .dx-selection,
.salarii-grid .dx-datagrid-rowsview .dx-row-focused {
  background: #27406b !important;
  color: #fff;
}

/* rand filtru */
.salarii-grid .dx-datagrid-filter-row td {
  background: #dfe4ee;
  border-bottom: 1px solid #c6cfde;
}

.salarii-grid .dx-datagrid-filter-row .dx-editor-with-menu .dx-texteditor-input {
  height: 26px;
  font-size: 12px;
}

/* celule compacte */
.salarii-grid .dx-data-row td {
  padding: 4px 6px;
  font-size: 13px;
}

/* iconite albe in header */
.salarii-grid .dx-datagrid-headers .dx-sort,
.salarii-grid .dx-datagrid-headers .dx-header-filter {
  color: #fff;
}

</style>
